module.exports = __webpack_public_path__ + "static/media/nav_arrow_down.777de94a.svg";